/* istanbul ignore file */
import { useFieldHelper } from 'framework/ui/field';
import { useAuthorization } from 'framework/authorization';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/IndeterminateCheckBox';
import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { useIsMyProfile } from 'domain/shared/employee';
import { ExpertisePermission } from 'domain/people/employee/expertise/service/expertiseService.model';
import useExpertiseService from 'domain/people/employee/expertise/service/expertiseService';

const DeleteExpertiseAction = () => {
  const isMyProfile = useIsMyProfile();
  const { isGranted } = useAuthorization();
  const { deleteEmployeeExpertise } = useExpertiseService();
  const { getValue } = useFieldHelper({ source: 'id' });
  const id = getValue();

  if (!isGranted(ExpertisePermission.PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_DELETE) || isMyProfile) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      modalConfirmButtonText="Delete"
      buttonTag={IconButton}
      sx={{
        p: 0,
        minWidth: 'auto',
      }}
      submitMethod={() => deleteEmployeeExpertise(id)}
      displayMessage="Do you really want to delete this expertise?"
      permissionToCheck={ExpertisePermission.PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_DELETE}
    >
      <RemoveIcon />
    </ButtonWithConfirmation>
  );
};

export default DeleteExpertiseAction;
